import { Cost } from "./Cost";
import { DiscountType } from "./DiscountType";
import { RawCost } from "./RawCost";


export class Discount extends Cost
{
    constructor(raw?: RawCost)
    {
        super(raw);
    }

    public CalcValue(price: number): number
    {
        switch (this.Type.value)
        {
            case DiscountType.Percent:
                return Math.round(price * (this.Value.value / 100));

            case DiscountType.LimitedPercent:
                const percentValue = Math.round(price * (this.Value.value / 100));
                if (percentValue > this.Limit.value)
                {
                    return this.Limit.value;
                }
                return percentValue;

            case DiscountType.FixedPrice:
                return this.Value.value;
        }
    }

    public AsString(price: number): string
    {
        if (price == 0)
        {
            return `${this.Value.value}% zniżki za ${this.Name.value}`;
        }

        const discount = this.CalcValue(price).toFixed(0);
        return `${discount}zł zniżki za ${this.Name.value}`;
    }
}
